import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader.js'
import {BaseLoader} from './BaseLoader'

/**
 * Базовый класс для загрузчиков, использующих GLTF модели
 * Устраняет дублирование кода загрузки GLTF файлов
 */
export abstract class BaseGltfLoader extends BaseLoader {
  protected readonly gltfLoader: GLTFLoader
  protected readonly loadPromise: Promise<void>

  constructor(gltfLoader?: GLTFLoader) {
    super()
    this.gltfLoader = gltfLoader || new GLTFLoader()
    this.loadPromise = this.createLoadPromise()
    void this.loadPromise
  }

  /**
   * Создание Promise для загрузки ресурсов
   * Переопределяется в подклассах
   */
  protected abstract createLoadPromise(): Promise<void>

  /**
   * Ожидание загрузки всех ресурсов
   */
  async waitForLoad(): Promise<void> {
    return this.loadPromise
  }

  /**
   * Загрузка одного GLTF файла
   * Утилитный метод для подклассов
   */
  protected loadGltfFile(
    path: string,
    onLoad: (gltf: any) => void,
    onError?: (error: unknown) => void
  ): void {
    this.gltfLoader.load(
      path,
      onLoad,
      undefined,
      onError ||
        ((error) => {
          console.error(`Failed to load GLTF file: ${path}`, error)
        })
    )
  }
}
